import { formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import type { PayloadAction } from '@reduxjs/toolkit'
import { getConfig } from 'config/configuration'
import { requestFilterDeletePermissions } from 'redux/redux-modules'
import { all, put } from 'redux-saga/effects'

import type { UnpublishSectionActionPayload } from '../actions'

export function* unpublishSectionSaga({
  payload: { section },
}: PayloadAction<UnpublishSectionActionPayload>) {
  const permissions = section.permissionAssignments

  const { endpoints } = getConfig()

  const deleteRequests = permissions.map(({ id }) =>
    put(
      requestFilterDeletePermissions.actions.makeRequest({
        url: formatEndpoint(endpoints.api.v5.requestFilterDeletePermissions, { id }),
      }),
    ),
  )

  yield all(deleteRequests)
}
